import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.2} fill="#F3FAF6" />
    <G clipPath="url(#clip0_997_4648)">
      <Path
        opacity={0.2}
        d="M20.0101 29.2255C24.6072 29.2255 28.3339 25.4988 28.3339 20.9017C28.3339 16.3046 24.6072 12.5779 20.0101 12.5779C15.413 12.5779 11.6863 16.3046 11.6863 20.9017C11.6863 25.4988 15.413 29.2255 20.0101 29.2255Z"
        fill="#0E8741"
      />
      <Path
        d="M20.0101 29.2255C24.6072 29.2255 28.3339 25.4988 28.3339 20.9017C28.3339 16.3046 24.6072 12.5779 20.0101 12.5779C15.413 12.5779 11.6863 16.3046 11.6863 20.9017C11.6863 25.4988 15.413 29.2255 20.0101 29.2255Z"
        stroke="#0E8741"
        strokeWidth={1.3873}
        strokeMiterlimit={10}
      />
      <Path
        d="M16.8886 20.2079C17.4633 20.2079 17.9291 19.7421 17.9291 19.1674C17.9291 18.5928 17.4633 18.127 16.8886 18.127C16.314 18.127 15.8481 18.5928 15.8481 19.1674C15.8481 19.7421 16.314 20.2079 16.8886 20.2079Z"
        fill="#0E8741"
      />
      <Path
        d="M23.1315 20.2079C23.7062 20.2079 24.172 19.7421 24.172 19.1674C24.172 18.5928 23.7062 18.127 23.1315 18.127C22.5569 18.127 22.0911 18.5928 22.0911 19.1674C22.0911 19.7421 22.5569 20.2079 23.1315 20.2079Z"
        fill="#0E8741"
      />
      <Path
        d="M23.4782 25.0635C22.7586 23.8193 21.5508 22.9825 20.01 22.9825C18.4692 22.9825 17.2614 23.8193 16.5417 25.0635"
        stroke="#0E8741"
        strokeWidth={1.3873}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_997_4648">
        <Rect
          width={22.1968}
          height={22.1968}
          fill="white"
          transform="translate(8.91162 9.80322)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
